module.exports = __webpack_public_path__ + "img/img1.36891628.png";